import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { isEmpty, pickBy } from 'lodash'
import ProductDB from '@store/db/ProductDB'
import StoreDB from '@store/db/StoreDB'
import BirdgeDB from '@store/db/BridgeDB'
import * as api from '@/modules/api'
import { initVal, statusInitVal, filterType } from '@data/filter.js'
import * as Status from '@data/status.js'

export const getData = createAsyncThunk(
  'data/getData',
  async () => await api.data()
)

let productDB = null
let storeDB = null
let birdgeDB = null

export const dataSlice = createSlice({
  name: 'data',
  initialState: {
    status: statusInitVal,
    // filtered items
    productList: [],
    storeList: [],
    // orginal items
    products: [],
    stores: [],
    filter: {
      city: initVal,
      district: initVal,
      channel: initVal,
      brand: initVal,
      product: initVal,
      period: initVal
    },
    isOnlyDelivery: false
  },
  reducers: {
    setOnlyDelivery(state, action) {
      state.isOnlyDelivery = action.payload
    },
    setFilter(state, action) {
      const allFilter = action.payload
      state.filter = allFilter
      // 去掉filter內value不是all的proerty e.g. { a: '123', b: 'all' } => { a: '123' }
      const filter = pickBy(state.filter, (val) => val !== initVal)

      if (isEmpty(filter)) {
        if (state.isOnlyDelivery) {
          // 如果是在特約取貨門市頁面，signable是true的store才是特約取貨門市，
          state.productList = []
          state.storeList = state.stores.filter(store => store.signable)
          return
        }
        state.productList = state.products
        state.storeList = state.stores
        return
      }
      if (!storeDB || !productDB || !birdgeDB) return

      // 如果是在特約取貨門市頁面，因為只搜尋門市，就不用搜尋商品
      if (state.isOnlyDelivery) {
        const storeList = storeDB.filter(filter, null,state.isOnlyDelivery)
        state.productList = []
        state.storeList = storeList
        return
      }

      // 如果是購物門市據點，就比較products/store哪種類型的篩選類型被選擇的篩選條件數量比較多
      const keys = Object.keys(filter)
      const storeFiltersCount = filterType.store.reduce((count, key) => count + keys.includes(key) ? 1 : 0, 0)
      const productFiltersCount = filterType.product.reduce((count, key) => count + keys.includes(key) ? 1 : 0, 0)

      console.time('get product/store')
      // console.log(filter)
      if (productFiltersCount >= storeFiltersCount) {
        const productList = productDB.filter(filter)
        // console.log(productList)
        // =AAA | =BBB | =CCC
        const productIds = productList.map(product => ({ productid: `=${product.productid}` }))
        // const productIds = productList.map(product => `=${product.productid}`).join(' | ')
        // console.log(productIds)
        const matchs = birdgeDB.search({ $or: productIds })
        // console.log(matchs)
        const storeIds = matchs.map(match => ({ storeid: `=${match.storeid}` }))
        // console.log(storeIds)
        const storeList = storeDB.filter(filter, storeIds)
        // console.log(storeList)
        state.productList = productList
        state.storeList = storeList
      } else {
        const storeList = storeDB.filter(filter)
        // console.log(storeList)
        const storeIds = storeList.map(store => ({ storeid: `=${store.storeid}` }))
        // const storeIds = storeList.map(store => `=${store.storeid}`).join(' | ')
        // console.log(storeIds)
        const matchs = birdgeDB.search({ $or: storeIds })
        // console.log(matchs)
        const productIds = matchs.map(match => ({ productid: `=${match.productid}` }))
        // console.log(productIds)
        const productList = productDB.filter(filter, productIds)
        // console.log(productList)
        state.productList = productList
        state.storeList = storeList
      }
      console.timeEnd('get product/store')
    },
  },
  extraReducers: {
    [getData.pending]: (state, action) => {
      state.status = Status.LOADING
    },
    [getData.fulfilled]: (state, action) => {
      const [stores, products, bridges] = action.payload
      state.stores = stores
      storeDB = new StoreDB(stores)

      state.products = products
      productDB = new ProductDB(products)

      birdgeDB = new BirdgeDB(bridges)
      state.status = Status.SUCCESS
    },
    [getData.rejected]: (state, action) => {
      state.status = Status.FAIL
    }
  }
})

export const { setOnlyDelivery, setFilter } = dataSlice.actions

export default dataSlice.reducer
